import React from "react";
import Lozenge from "../../../components/BaseUI/Lozenge";
import { Td } from "../../../components/BaseUI/Table";
import ApprovalResultBadge from "../../ApprovalResultBadge";
import { formatInstantDateShortTr } from "../../../utils/appTime";
import { limitWords } from "../../../utils/textDisplay";
import ProductPrice from "../../../components/CustomUI/ProductPrice";
import {
  parseRateNum,
  formatRateDisplay,
} from "../order/orderDetailUtils";
import { approveSale, rejectSale } from "./api";
import SaleDetailBody from "./SaleDetailBody";

const getEntity = (item) => item?.entity ?? item;
const getId = (item) => item?.entityId ?? getEntity(item)?._id ?? item?.id;
const companyName = (item) =>
  getEntity(item)?.companyId?.name || item?.summary?.companyName || "-";

const renderCells = (item, { format, visibleColumns, fx }, history = false) => {
  const show = (id) => !visibleColumns || visibleColumns.includes(id);
  const compName = companyName(item);
  const rate = item?.summary?.exchangeRate ?? getEntity(item)?.exchangeRate;
  const rateNum = parseRateNum(rate);
  const isFallback = !rateNum && !!fx?.rate;
  const displayRate = rateNum ?? parseRateNum(fx?.rate);

  const date = history
    ? item?.resolvedAt || item?.requestedAt
    : item?.requestedAt;

  const actor = history
    ? item?.resolvedBy?.name || item?.requestedBy?.name || "-"
    : item?.createdBy?.name || item?.requestedBy?.name || "-";

  return (
    <>
      {show(0) && (
        <Td>
          <Lozenge appearance="info-subtle">Sipariş</Lozenge>
        </Td>
      )}
      {show(1) && (
        <Td>
          <span className="fw-semibold">{limitWords(item?.title || "")}</span>
        </Td>
      )}
      {show(2) && <Td>{limitWords(compName === "-" ? "" : compName)}</Td>}
      {show(3) && (
        <Td>
          <span className="fw-semibold text-primary">
            <ProductPrice
              value={item?.summary?.totalAmount || 0}
              rate={rateNum}
              showFallbackMark={isFallback}
            />
          </span>
        </Td>
      )}
      {show(9) && (
        <Td>
          {displayRate ? (
            <span>
              {formatRateDisplay(displayRate)}
              {isFallback && (
                <span className="text-warning fw-bold ms-1" title="Güncel kur">
                  *
                </span>
              )}
            </span>
          ) : (
            "-"
          )}
        </Td>
      )}
      {show(4) && (
        <Td>
          <ApprovalResultBadge item={item} />
        </Td>
      )}
      {show(5) && <Td>{actor}</Td>}
      {show(6) && <Td>{item?.previousStepApprovedBy?.name || "-"}</Td>}
      {show(7) && <Td>{date ? formatInstantDateShortTr(date) : "-"}</Td>}
    </>
  );
};

export const saleApprovalPlugin = {
  type: "sale",
  typeLabel: "Sipariş",
  getId,
  getEntity,
  getTitle: (item) => item?.title || getEntity(item)?.saleName || "",
  stages: {
    admin: {
      canActOn: (item) => item?.status === "pending",
      approve: (item, { token, attachment }) =>
        approveSale(token, getId(item), attachment),
      reject: (item, reason, { token }) =>
        rejectSale(token, getId(item), reason),
      messages: {
        approveSuccess: "Sipariş onayı tamamlandı",
        rejectSuccess: "Sipariş onayı reddedildi",
      },
      approveLabel: "Onayla",
      rejectLabel: "Reddet",
      rejectModalTitle: "Sipariş Onayını Reddet",
      detailTitle: "Sipariş Detayı",
    },
  },
  inbox: {
    detailWidth: "large",
    renderDetailHeader: (item) => (
      <div>
        <strong>{item?.title || getEntity(item)?.saleName}</strong>
        <div className="text-muted small">{companyName(item)}</div>
      </div>
    ),
    renderDetailBody: (item, { format, detailSection }) => (
      <SaleDetailBody
        sale={getEntity(item)}
        format={format}
        rejectReason={item?.reason}
        detailSection={detailSection}
      />
    ),
    renderRowCells: (item, context) => renderCells(item, context),
    renderHistoryCells: (item, context) => renderCells(item, context, true),
  },
};

export default saleApprovalPlugin;
